import { useState } from 'react'
import { Mail, Phone, MapPin, Clock, Send } from 'lucide-react'
import SEO from '../components/SEO'
import './ContactUs.css'

export default function ContactUs() {
  const [sent, setSent] = useState(false)
  const [form, setForm] = useState({ name: '', email: '', company: '', product: '', message: '' })

  const handleSubmit = (e) => {
    e.preventDefault()
    setSent(true)
  }

  return (
    <>
      <SEO title="Contact Us" description="Get in touch with NexCore Solutions to schedule a product demo, request a quote, or talk to our enterprise software specialists." keywords="contact NexCore Solutions, enterprise software demo, HCM demo India, ERP consultation Chennai" path="/contact" />
      <section className="page-hero">
        <div className="container">
          <p className="section-label">Get in Touch</p>
          <h1 className="section-title">Let's talk about your business</h1>
          <p className="section-subtitle">Schedule a product demo, request a quote, or simply ask us a question. Our team responds within one business day.</p>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <div className="contact-inner">
            <div className="contact-info">
              <h2>We're here to help</h2>
              <p>Whether you're evaluating our products, planning a migration, or looking to understand what's right for your business — reach out.</p>
              <div className="contact-details">
                <div className="contact-detail"><div className="contact-detail__icon"><Mail size={18} /></div><div><strong>Email Us</strong><span>hello@nexcoresolutions.com</span></div></div>
                <div className="contact-detail"><div className="contact-detail__icon"><Phone size={18} /></div><div><strong>Call Us</strong><span>+91 44 4000 0000</span></div></div>
                <div className="contact-detail"><div className="contact-detail__icon"><MapPin size={18} /></div><div><strong>Visit Us</strong><span>NexCore Solutions Pvt. Ltd.<br />4th Floor, Cyber Tower, Tidel Park<br />Chennai – 600 113, Tamil Nadu</span></div></div>
                <div className="contact-detail"><div className="contact-detail__icon"><Clock size={18} /></div><div><strong>Business Hours</strong><span>Monday – Friday, 9:00 AM – 6:00 PM IST</span></div></div>
              </div>
            </div>

            <div className="contact-form-wrap">
              {sent ? (
                <div className="contact-success">
                  <div className="contact-success__icon">✓</div>
                  <h3>Message received!</h3>
                  <p>Thanks for reaching out. One of our specialists will get back to you within one business day.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <h3>Send us a message</h3>
                  <div className="form-row">
                    <div className="form-field">
                      <label>Full Name *</label>
                      <input type="text" required placeholder="Your full name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} />
                    </div>
                    <div className="form-field">
                      <label>Work Email *</label>
                      <input type="email" required placeholder="you@company.com" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-field">
                      <label>Company Name</label>
                      <input type="text" placeholder="Your company" value={form.company} onChange={e => setForm({...form, company: e.target.value})} />
                    </div>
                    <div className="form-field">
                      <label>Product Interest</label>
                      <select value={form.product} onChange={e => setForm({...form, product: e.target.value})}>
                        <option value="">Select a product</option>
                        <option>Human Capital Management</option>
                        <option>Takeaway System</option>
                        <option>Account Management</option>
                        <option>Textile ERP</option>
                        <option>Manufacturing Inventory</option>
                        <option>Multiple Products</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-field">
                    <label>Message *</label>
                    <textarea required rows={5} placeholder="Tell us about your requirements..." value={form.message} onChange={e => setForm({...form, message: e.target.value})} />
                  </div>
                  <button type="submit" className="btn-primary contact-submit">Send Message <Send size={16} /></button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
